import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCartPlus,
  faCircleCheck,
  faCircleXmark,
  faFileImage,
} from "@fortawesome/free-solid-svg-icons";

import { getColorsElements, getMethodDisplay } from "./ProductDetailsLogo";
import { BaseLogo, isDigital } from "../../../../core/models/entities/BaseLogo";
import { LogoSize } from "../../../components/Logo/LogoSize";
import IconButton from "../../../components/LogoButton/IconButton";
import { Color } from "../../../../core/models/entities/LogoOptions";
import { ReactNode } from "react";

interface DesignPrintItemProps {
  logo: BaseLogo;
  addMoreAction?: () => void;
  placements?: string;
  colors: ReactNode;
}
export const DesignPrintItem = ({
  logo,
  addMoreAction,
  colors,
  placements,
}: DesignPrintItemProps) => {
  const isRaster = isDigital(logo);
  const alt = `Logo - ${logo.title}`;
  const src = logo.displayImage.lowResUrl;

  return (
    <div className="flex flex-col bg-white">
      <div className="flex flex-row items-center p-1.5 font-bold gap-2 text-[#1B76DF] bg-gray-100 border-x  border-t rounded-t">
        <div className="border rounded-sm p-1 px-2 text-[#1B76DF] text-xs bg-[#FFFFFF]">
          <FontAwesomeIcon size={"1x"} icon={faFileImage} />
        </div>
        <div className="truncate text-[#1B76DF] text-xs font-bold">
          <a
            href={`/logo?searchTerm=${logo.product?.sku}&pageSize=25&pageIndex=1`}
            className={"hover:underline"}
          >
            {logo.title}
          </a>
        </div>
      </div>
      <div className="flex flex-row border-y bg-gray-100 border-x rounded-b">
        <div className="bg-white w-[120px] max-h-[140px] flex items-center justify-center">
          <img
            className={
              "w-[70px] h-[45px] object-contain bg-white rounded hover:border hover:p-2 origin-left hover:scale-[4] hover:ease-out transition-all duration-150 ease-out z-40"
            }
            src={src}
            alt={alt}
          />
        </div>
        <div className={"flex flex-col gap-1 text-xs p-2"}>
          {logo.product?.sku && (
            <div className="flex flex-row gap-x-1 capitalize">
              <b>Item No.</b>
              <a
                href={`/logo?searchTerm=${logo.product?.sku}&pageSize=25&pageIndex=1`}
                className={"hover:underline"}
              >
                {logo.product?.sku}
              </a>
            </div>
          )}
          <div className="flex flex-row gap-x-1 capitalize">
            <b>Type</b>
            {logo.transferMethod.type.toLowerCase() === "direk tryk" ||
            logo.transferMethod.type.toLowerCase() === "screen print"
              ? "Screen Print"
              : logo.transferMethod.type.toLowerCase() === "broderi" ||
                logo.transferMethod.type.toLowerCase() === "embroidery"
              ? "Embroidery"
              : logo.transferMethod.type
                  .toLowerCase()
                  .split(" ")
                  .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                  .join(" ")}
          </div>
          {logo.transferMethod.type.toLowerCase() !== "direk tryk" &&
            logo.transferMethod.type.toLowerCase() !== "screen print" &&
            logo.transferMethod.type.toLowerCase() !== "broderi" &&
            logo.transferMethod.type.toLowerCase() !== "embroidery" && (
              <div className="flex flex-row gap-x-1 capitalize">
                <b>Method</b>
                {getMethodDisplay(logo)}
              </div>
            )}
          <div className="flex flex-row items-center gap-x-1">
            <b>Size</b>
            <LogoSize logo={logo} format="WWxYYmm" />
          </div>
          {placements && (
            <p>
              <b>Placement</b> {placements}
            </p>
          )}
          {addMoreAction && Math.max(0, logo?.inStorage ?? 0) > 0 && (
            <p>
              <b>In Storage</b> {Math.max(0, logo?.inStorage ?? 0)}
            </p>
          )}
          <div className="flex flex-row gap-x-1 -mb-1">
            <span>
              <b>COLORS</b>
            </span>
            <div>{colors}</div>
          </div>
          {(logo.transferMethod.type.toLowerCase() === "direk tryk" ||
            logo.transferMethod.type.toLowerCase() === "screen print" ||
            logo.transferMethod.type.toLowerCase() === "broderi" ||
            logo.transferMethod.type.toLowerCase() === "embroidery") && (
            <div className="h-3"></div>
          )}
          {addMoreAction && (
            <IconButton
              key={"add-order"}
              onClick={addMoreAction}
              icon={<FontAwesomeIcon icon={faCartPlus} />}
            >
              ADD MORE
            </IconButton>
          )}
        </div>
      </div>
    </div>
  );
};
